import { RoutingEndpoints } from '@/constants';
import { AUTH_AUTHORITY } from '@/constants/auth';
import { User } from 'oidc-client-ts';
import { HttpClient } from '.';
import { OnHttpRequest, OnHttpResponse } from './interceptors';

function getCurrentUser() {
  const oidcStorage = localStorage.getItem(
    `oidc.user:${AUTH_AUTHORITY}:${import.meta.env.VITE_APP_AUTH_CLIENT_ID}`,
  );
  if (!oidcStorage) {
    return null;
  }

  return User.fromStorageString(oidcStorage);
}

export class ProtectedHttpClient extends HttpClient {
  constructor(resource: string) {
    super(resource);

    const handleRequest: OnHttpRequest = (config, headers) => {
      const token = getCurrentUser()?.access_token;
      const organizationId = sessionStorage.getItem('organizationId');
      config.headers = config.headers.concat({
        ...headers,
        Authorization: `Bearer ${token}`,
        'Organization-Id': organizationId,
      });
      return config;
    };

    const handleErrorResponse: OnHttpResponse = {
      error(error) {
        if (error.statusCode === 401) {
          window.location.href = RoutingEndpoints.home();
        }
        throw error;
      },
    };

    this.setOnRequest(handleRequest).setOnResponse(handleErrorResponse);
  }
}
